import { BrowserRouter, HashRouter } from "react-router-dom";
import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { platformServices } from "./platform/platform";
import { AuthProvider } from "./state/AuthProvider";
import { ThemeProvider } from "./theme/ThemeProvider";
import { initAppTheme } from "./theme/appTheme";
import "./styles.css";
import "./styles/app-theme.css";
import "./styles/auth-surfaces.css";
import "./styles/account-menu.css";

initAppTheme();

function AppRouter({ children }: { children: ReactNode }) {
  const Router = platformServices.isNative ? HashRouter : BrowserRouter;
  return <Router>{children}</Router>;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <AppRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </AppRouter>
    </ThemeProvider>
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js"));
}
